import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, PenSquare, Package, History, ScanLine } from "lucide-react";
import { useFeatureAccess } from "@/hooks/useFeatureAccess";

const TABS = [
  { to: "/entry", icon: PenSquare, label: "Daily Lottery", testId: "lottery-tab-entry" },
  { to: "/", icon: LayoutDashboard, label: "Dashboard", testId: "lottery-tab-dashboard" },
  { to: "/stock", icon: Package, label: "Stock", testId: "lottery-tab-stock" },
  { to: "/history", icon: History, label: "History", testId: "lottery-tab-history" },
  { to: "/lotto-scan", icon: ScanLine, label: "Lotto Scanning", testId: "lottery-tab-lotto-scan", access: "lotto_scan" },
];

// Sub-tab strip shown on all lottery-related pages (entry/dashboard/stock/history).
export const LotteryTabs = () => {
  const { pathname } = useLocation();
  const lottoScanAccess = useFeatureAccess("lotto_scan");
  const accessMap = { lotto_scan: lottoScanAccess.canAccess };
  const isActive = (to) => (to === "/" ? pathname === "/" : pathname.startsWith(to));
  const visibleTabs = TABS.filter((t) => !t.access || accessMap[t.access]);
  return (
    <div className="flex items-center gap-1.5 mb-4 overflow-x-auto print:hidden" data-testid="lottery-subtabs">
      {visibleTabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={`nav-3d flex items-center gap-1.5 px-3 py-1.5 rounded-lg font-mono text-xs sm:text-sm flex-shrink-0 whitespace-nowrap ${isActive(t.to) ? "active" : ""}`}
          data-testid={t.testId}
        >
          <t.icon className="w-3.5 h-3.5 sm:w-4 sm:h-4" strokeWidth={2} />
          {t.label}
        </NavLink>
      ))}
    </div>
  );
};
